import React, { useState } from 'react';
import { Alert, Button, Card } from 'react-bootstrap';
import LargeUserPill from '../../common/components/LargeUserPill';
import { Icon } from '../../common/components/Utilities';

export default function ({
  group, candidates, canVolunteer, userIsCandidate,
}) {
  const [assertion, setAssertion] = useState(false);

  return (
    <>
      <Card className="mb-4">
        <Card.Header>
          Candidates
        </Card.Header>
        <table className="table mb-0">
          <thead>
            <tr>
              <th>Candidate</th>
              <th>Nomination Statement</th>
            </tr>
          </thead>
          <tbody>
            {Object.values(candidates).map((candidate) => (
              <tr>
                <td>
                  <LargeUserPill user={candidate.user} />
                </td>

                <td>
                  <Alert variant="info" className="mb-0 small text-muted">{candidate.statement}</Alert>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>

      {userIsCandidate ? (
        <Alert variant="success">
          <Icon icon="check-circle" append="mr-2" />
          You have nominated yourself as a candidate to represent your constituency.
        </Alert>
      ) : (
        <Card>
          <Card.Header>Nominate yourself as a candidate</Card.Header>
          <Card.Body>
            <Alert variant="warning" className="mb-4">
              To nominate yourself as a candidate to represent your group, you must:

              <ul className="mb-0">
                <li>Be an employee of the Company</li>
                <li>Have passed your probation period.</li>
                <li>Not be working your notice period.</li>
                <li>Be based in the UK and on a UK employment contract.</li>
                <li>Not be undergoing disciplinary or performance management processes.</li>
                <li>Be available to participate in all upcoming consultation meetings.</li>
                <li>
                  Be able to represent your group effectively,
                  collating their feedback and questions,
                  and sharing outcomes back to the group.
                </li>
              </ul>
            </Alert>
            {canVolunteer ? (
              <form action="/group-candidates" method="POST">
                <input type="hidden" name="_token" value={window.props.csrfToken} />
                <input type="hidden" name="group_id" value={group.id} />

                <div className="form-group">
                  <label className="mb-0" style={{ fontWeight: 'bold' }} htmlFor="statement">Statement</label>
                  <small className="form-text text-muted mb-4">Outline in a few words why you think you would be the best person to represent your group.</small>
                  <textarea className="form-control" maxLength={200} minLength={25} rows={3} name="statement" id="statement" />
                </div>

                <div className="form-group form-check">
                  <input type="checkbox" className="form-check-input" id="assertion" onChange={(event) => setAssertion(event.target.checked)} />
                  <label className="form-check-label" htmlFor="assertion">
                    I agree to being nominated as a candidate for election as an
                    employee representative in connection with the proposed
                    redundancies at Gear4Music Limited, 1 St Peters Square,
                    Manchester, M2 3DE.
                  </label>
                </div>

                <Button type="submit" variant="primary" disabled={!assertion}>Add my nomination</Button>
              </form>

            ) : (
              <div className="text-danger">
                It does not look like you are eligible to nominate yourself as a candidate.
                If you think you should be, please speak to Dan.
              </div>
            )}
          </Card.Body>
        </Card>
      )}
    </>
  );
}
